export enum MarkerSize {
  MD = 'md',
  RG = 'rg',
  SM = 'sm',
}

export enum MarkerType {
  Default = 'default',
  Highlighted = 'highlighted',
  Selected = 'selected',
  Viewed = 'viewed',
  Location = 'location'
}

export interface MarkerAddress {
  MainText: string;
  City: string;
  Country: string;
}
